import { Input, Radio, Checkbox, Switch, Select, InputNumber } from 'ant-design-vue'

/**
 * 支持的component列在这里, SchemaForm组件索引.[formMetas.schemas.component]对应的<Component>进行渲染
 * {FormControl}是指对表单元素有实现的组件，例如antd的Input
 * @typedef {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} FormControl
 * @type {{[component: string]: FormControl}}
 */
const supportFormControlComponent = {
  Input,
  Radio,
  Checkbox,
  Switch,
  Select,
  InputNumber,
  TextArea: Input.TextArea,
  InputPassword: Input.Password,
  Search: Input.Search,
  CheckboxGroup: Checkbox.Group,
  RadioGroup: Radio.Group
}

export const inputComponentNames = [
  Input.name,
  Input.TextArea.name,
  Input.Password.name,
  Input.Search.name,
  InputNumber.name
]

export const selectComponentName = Select.name

export {
  supportFormControlComponent
}
